import { render, staticRenderFns } from "./EditTestButton.vue?vue&type=template&id=78458f4b&scoped=true&"
import script from "./EditTestButton.vue?vue&type=script&lang=js&"
export * from "./EditTestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78458f4b",
  null
  
)

export default component.exports